var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("path", {
    stroke: props.color,
    d: "M16.5 9L12 4 7.5 9m4.5 7.5v-12m8.5 6.5v8.5a1 1 0 01-1 1h-15a1 1 0 01-1-1V11"
  }));
}
export default SvgIconShare;